import React from 'react';

interface FormSelectorLogoProps {
    logoName: React.ReactNode;
    logoUrl: string;
    isSelected?: boolean;
}

export const FormSelectorLogo: React.FC<FormSelectorLogoProps> = ({ logoName, logoUrl, isSelected }) => {
    const [isValid, setIsValid] = React.useState(true);
    const paddingRight = isSelected ? '24px' : 0;
    return (
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', paddingRight }}>
            <span>{logoName}</span>
            {logoUrl && isValid && (
                <img
                    src={logoUrl}
                    alt={`Logo for ${logoName}`}
                    style={{ height: 20 }}
                    onError={() => setIsValid(false)}
                />
            )}
        </div>
    );
};
